import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-user-workingdays-view',
  templateUrl: './user-workingdays-view.component.html',
  styleUrls: ['./user-workingdays-view.component.css']
})
export class UserWorkingdaysViewComponent implements OnInit {

  constructor(private brandService: ServiceService, private route: ActivatedRoute, private router: Router) { }
  output: any = []; //---store get() result--------
  KpiId = '';
  //getUrl='http://192.241.151.66:5000/viewBrands';
  imgUrl = this.brandService.ReturnBase();
  name = ""
  getdata: any = [];
  setData: any;
  array: any;
  user_id=null

  //------routing to edit page--------------------
  EditItem() {
    var Id=this.user_id
    this.router.navigate(['admin/user-working-days-edit'],{queryParams:{setData:JSON.stringify({Id})}});
  }

  //--------function which give id of selected customer---------
  getValue() {
    this.brandService.setKPIId(this.KpiId)
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }

  //-------date formating-------------

  today: Date = new Date();
  pipe = new DatePipe('en-US');
  todayWithPipe: any = null;

  DateFormat(value: any) {
    //-------date formating----------------------
    this.todayWithPipe = this.pipe.transform(value, 'MMM d, y, h:mm:ss a');
    let myString = this.todayWithPipe
    myString = myString.substr(0, myString.length - 13);
    return myString
  }
      //--------------function for date formating-----------------
      formatDate(dateStr: string): any {
        if(dateStr==null)
        return
        const [year, month] = dateStr.split('-');
        const date = new Date(`${year}-${month}-01`);
    
        const formattedDate = new Intl.DateTimeFormat('en-US', { month: 'long', year: 'numeric' }).format(date);
        return formattedDate;
      }

  DateFormat1(value: any) {
    //-------date formating----------------------
    this.todayWithPipe = this.pipe.transform(value, 'MMM d, y, h:mm:ss a');

    return this.todayWithPipe
  }
  ngOnInit(): void {

 
    this.route.queryParams.subscribe((params) => {
      this.getdata = params;
      this.setData = this.getdata.setData;
      const obj = JSON.parse(this.setData);
      this.array = [obj];
      this.user_id = this.array[0].Id;
    })

    //-------api get()calling-------------
    this.brandService.viewUserWorkingDaysEach(this.user_id).subscribe((res) => {
    
      this.output = res.data
      console.log("res=",this.output.month_year)
    })
  }

}

